import _ from 'lodash';

type Action = 'ADD' | 'UPDATE' | 'REMOVE';
type Change<T> = Partial<T> & { action?: Action };

export function syncDataSocket<T extends Record<string, any>>(
  oldData: T[],
  newData: Change<T>[],
  uniqueKey: keyof T | string
): T[] {
  const getId = (obj: Partial<T>): string | undefined => {
    const v = _.get(obj, uniqueKey as any);
    return v == null ? undefined : String(v);
  };

  const latestChangeById = _(newData)
    .filter((c) => getId(c) !== undefined)
    .groupBy((c) => getId(c)!)
    .mapValues((arr) => _.last(arr)!)
    .value();

  const oldMap: Record<string, T> = _.keyBy(
    oldData.filter((x) => getId(x) !== undefined),
    (x) => getId(x)!
  );

  _.forEach(latestChangeById, (chg, id) => {
    if (chg.action === 'REMOVE') {
      if (oldMap[id]) delete oldMap[id];
    } else if (chg.action === 'UPDATE') {
      if (oldMap[id]) {
        oldMap[id] = Object.assign({}, oldMap[id], _.omit(chg, 'action')) as T;
      }
    }
  });

  const kept = oldData
    .map((x) => {
      const id = getId(x);
      return id ? oldMap[id] : undefined;
    })
    .filter((x): x is T => Boolean(x));

  const added = _(latestChangeById)
    .toPairs()
    .filter(([, chg]) => chg.action === 'ADD')
    .filter(([id]) => !oldMap[id]) // 
    // @ts-ignore
    .map(([, chg]) => _.omit(chg, 'action') as T)
    .value();

  return kept.concat(added);
}
